import firebase from 'firebase/app'
import 'firebase/database'

async function uploadFileToStorage ({ file: { folder, file, fileData, filename, mimetype }, progressCallback }) {
  return new Promise((resolve, reject) => {
    const ref = firebase.storage().ref(folder)
    const child = ref.child(filename)
    let upload
    if (fileData) upload = child.putString(fileData, 'base64', { contentType: mimetype })
    else upload = child.put(file)
    if (progressCallback && typeof progressCallback === 'function') {
      progressCallback({
        progress: 5
      })
    }
    upload.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        console.log('Upload is ' + progress + '% done')
        if (progressCallback && typeof progressCallback === 'function') {
          progressCallback({
            progress
          })
        }
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused')
            break
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running')
            break
        }
      }, (error) => {
        console.log(error)
        reject(error)
      }, async () => {
        // Upload completed successfully, now we can get the download
        const url = await child.getDownloadURL()
        console.log('Url: ', url)

        if (progressCallback && typeof progressCallback === 'function') {
          progressCallback({
            progress: 100
          })
        }

        resolve({
          ref: child.fullPath,
          url
        })
      }
    )
  })
}

export {
  uploadFileToStorage
}
